import type { UpdateTruckInput } from '@chukua/common';
import type { TruckClass } from '../../../../reference-data/reference-data.api';
import { useTruckFuelEconomy } from '../hooks/use-truck-fuel-economy';
import { TruckDetailsForm, type TruckDetailsFormProps } from './TruckDetailsForm';
import { TruckFuelEconomyCard } from './TruckFuelEconomyCard';
import { TruckOdometerCard } from './TruckOdometerCard';
import type { TruckDetail } from '../trucks.api';

interface TruckDetailsTabProps {
  truck: TruckDetail;
  truckClasses: TruckClass[];
  canManage: boolean;
  error: string | null;
  saving: boolean;
  device: TruckDetailsFormProps['device'];
  onSave: (input: UpdateTruckInput, device: string | undefined) => Promise<boolean>;
  onRecordReading: (odometerKm: number) => Promise<boolean>;
}

/** The odometer card (its own "Record reading" control) above the editable record — CLAUDE.md: the odometer only moves through a reading. */
export function TruckDetailsTab({ truck, truckClasses, canManage, error, saving, device, onSave, onRecordReading }: TruckDetailsTabProps) {
  const fuelEconomy = useTruckFuelEconomy(truck.id);
  return (
    <div className="flex flex-col gap-8">
      <TruckOdometerCard
        currentOdometerKm={truck.currentOdometerKm}
        odometerRecordedAt={truck.odometerRecordedAt}
        canManage={canManage}
        onRecord={onRecordReading}
      />
      <TruckFuelEconomyCard state={fuelEconomy} />
      <TruckDetailsForm truck={truck} truckClasses={truckClasses} canManage={canManage} error={error} saving={saving} device={device} onSave={onSave} />
    </div>
  );
}
